// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging } from "firebase/messaging";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC8dVxFbX8A3yp_khbq9P818nd6Vy_7tbM",
  authDomain: "harinaam-sankirtan.firebaseapp.com",
  projectId: "harinaam-sankirtan",
  storageBucket: "harinaam-sankirtan.firebasestorage.app",
  messagingSenderId: "967771054754",
  appId: "1:967771054754:web:7fbb46161a59ba4f3f6dfb",
  measurementId: "G-KXEQRTRSKB"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const messaging = getMessaging(app);


export { messaging };